import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Edit2, Save, X } from 'lucide-react';

/**
 * Inline Notes Editor Component
 * 
 * Allows editing admin notes with save/cancel actions
 */
const NotesEditor = ({ initialNotes, onSave, disabled = false }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [notes, setNotes] = useState(initialNotes || '');
  
  useEffect(() => {
    setNotes(initialNotes || '');
  }, [initialNotes]);
  
  const handleSave = () => {
    onSave(notes);
    setIsEditing(false);
  };
  
  const handleCancel = () => {
    setNotes(initialNotes || '');
    setIsEditing(false);
  };
  
  if (!isEditing) {
    return (
      <div className="flex items-start gap-2">
        <div className="flex-1 text-sm text-gray-700">
          {notes || <span className="text-gray-400 italic">No notes</span>}
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => setIsEditing(true)}
          disabled={disabled}
        >
          <Edit2 className="h-4 w-4" />
        </Button>
      </div>
    );
  }
  
  return (
    <div className="space-y-2">
      <Textarea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder="Add admin notes..."
        rows={3}
        className="resize-none"
        disabled={disabled}
      />
      <div className="flex gap-2">
        <Button size="sm" onClick={handleSave} disabled={disabled}>
          <Save className="h-4 w-4 mr-1" />
          Save
        </Button>
        <Button size="sm" variant="outline" onClick={handleCancel} disabled={disabled}>
          <X className="h-4 w-4 mr-1" />
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default NotesEditor;